import { useState } from "react";
import { SHORT_HEIGHT, useWindowSize } from "./useCompact";

// A one-time tip on short windows (Review 17, C62): the Chromebook's full-screen key hides the
// browser bar and gives back about 85 pixels. Dismissed once, it stays gone on this computer.

const KEY = "buildlab-tip-fullscreen";

function dismissed(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function FullscreenTip() {
  const { h } = useWindowSize();
  const [gone, setGone] = useState(dismissed);
  // Already full screen (the window is as tall as the screen): nothing to suggest.
  const fullScreen = typeof screen !== "undefined" && h >= screen.height - 4;
  if (gone || h >= SHORT_HEIGHT || fullScreen) return null;
  const close = () => {
    setGone(true);
    try {
      localStorage.setItem(KEY, "1");
    } catch {}
  };
  return (
    <p className="fs-tip" role="note">
      <span>
        <b>More room:</b> press the full-screen key (<span className="fs-key" aria-hidden="true">⛶</span>
        <span className="sr-only">full-screen</span>, top row of the keyboard).
      </span>
      <button type="button" className="linklike" onClick={close}>
        Got it
      </button>
    </p>
  );
}
